import React from "react";
import { FaInstagram, FaLinkedin } from "react-icons/fa"; // Ícones do Instagram e LinkedIn
import { useParams } from "react-router-dom";
import styled from "styled-components";
import companiesData from "../components/data";

// Estilo do container principal
const Container = styled.div`
  width: 100%;
  max-width: 1300px;
  margin: 40px auto;
  padding: 30px;
  background-color: #f4f4f9;
  border-radius: 20px;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
  font-family: "Arial", sans-serif;
`;

// Título centralizado com fontes modernas
const Header = styled.h1`
  font-size: 2.5rem;
  color: #101828;
  text-align: center;
  margin-bottom: 20px;
  font-weight: 700;
`;

// Estilos do conteúdo, com layout flexível e responsivo
const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

// Container de informações
const InfoContainer = styled.div`
  flex: 2;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 15px;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.15);
  }
`;

// Estilo para o logo da empresa
const Logo = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  margin-bottom: 20px;
  object-fit: contain;
`;

// Texto com as informações de contato e detalhes da empresa
const Detail = styled.p`
  font-size: 1.2rem;
  color: #333;
  margin: 15px 0;
`;

// Social media links estilizados
const SocialMedia = styled.div`
  display: flex;
  gap: 12px;

  a {
    color: #101828; /* Cor atualizada */
    font-size: 1.8rem;
    text-decoration: none;
    font-weight: 600;

    &:hover {
      color: #005bb5;
    }
  }
`;

// Container de mapa com bordas arredondadas e estilo moderno
const MapContainer = styled.div`
  flex: 1;
  min-height: 350px;
  background: #e4ecf7;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.1);

  iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

// Formulário estilizado com bordas suaves
const FormContainer = styled.div`
  margin-top: 40px;
  padding: 25px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
`;

const FormTitle = styled.h2`
  font-size: 1.8rem;
  margin-bottom: 20px;
  color: #101828;
  font-weight: 700;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  font-size: 1rem;

  &:focus {
    border-color: #007aff;
    outline: none;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  font-size: 1rem;

  &:focus {
    border-color: #007aff;
    outline: none;
  }
`;

const SubmitButton = styled.button`
  background-color: #007aff;
  color: #ffffff;
  padding: 14px 25px;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  font-size: 1.2rem;
  width: 100%;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #0056b3;
  }
`;

// Componente principal
const CompanyDetails = () => {
  const { companyId } = useParams();
  const company = companiesData.find((comp) => comp.id === parseInt(companyId));

  if (!company) {
    return <Container>Empresa não encontrada.</Container>;
  }

  return (
    <Container>
      <Header>{company.nome}</Header>
      <Content>
        <InfoContainer>
          <Logo src={company.logo} alt={`Logo da ${company.nome}`} />
          <Detail>
            <strong>Endereço:</strong> {company.endereco}
          </Detail>
          <Detail>
            <strong>Contato:</strong> {company.contato}
          </Detail>
          <SocialMedia>
            {company.redesocial.map((link, idx) => (
              <a
                key={idx}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.nome === "Instagram" ? (
                  <FaInstagram />
                ) : link.nome === "LinkedIn" ? (
                  <FaLinkedin />
                ) : (
                  link.nome
                )}
              </a>
            ))}
          </SocialMedia>
        </InfoContainer>
        <MapContainer>
          <iframe
            src={`https://www.google.com/maps?q=${encodeURIComponent(
              company.endereco
            )}&output=embed`}
            title={`Mapa de localização de ${company.nome}`} // Atribua um título único e descritivo
            allowFullScreen
          ></iframe>
        </MapContainer>
      </Content>
      <FormContainer>
        <FormTitle>Deixe sua Avaliação</FormTitle>
        <form>
          <Input type="text" placeholder="Seu nome" />
          <Input type="number" placeholder="Sua nota (1 a 5)" />
          <TextArea rows="5" placeholder="Escreva sua avaliação"></TextArea>
          <SubmitButton type="submit">Enviar Avaliação</SubmitButton>
        </form>
      </FormContainer>
    </Container>
  );
};

export default CompanyDetails;
